import React, { useEffect, useState } from "react";
import { ChatCircleDots } from "@phosphor-icons/react";
import SocialHub from "@/components/SocialHub";

// Slide-over, never a layout-pushing panel: the optimizer grid stays put.
export default function HubDrawer() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
      if (e.key.toLowerCase() === "h" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="hub-drawer-open"
        title="Social Hub (⌘/Ctrl + H)"
        className="p-2 text-zinc-500 hover:text-[#39FF14] transition-colors border border-zinc-800 hover:border-[#39FF14]/50"
      >
        <ChatCircleDots size={14} />
      </button>
      {open && (
        <>
          <div
            className="fixed inset-0 bg-black/60 z-40 backdrop-blur-[2px]"
            onClick={() => setOpen(false)}
            data-testid="hub-drawer-scrim"
          />
          <aside
            className="fixed right-0 top-0 bottom-0 w-full sm:w-[460px] z-50 bg-[#0a0a0a] border-l border-zinc-800 flex flex-col mm-slide-in"
            data-testid="hub-drawer"
          >
            <div className="px-4 py-3 border-b border-zinc-800">
              <div className="overline text-[#39FF14]">Social Hub</div>
              <div className="mono text-[9px] text-zinc-600 mt-0.5">Slate rooms, live news, crowd sentiment</div>
            </div>
            <div className="flex-1 min-h-0">
              <SocialHub compact onClose={() => setOpen(false)} />
            </div>
          </aside>
        </>
      )}
    </>
  );
}
